// initial state
const state = {
  workInfoStatus: {
    0: '待审核',
    1: '审核通过',
    2: '审核未通过'
  },
  fields: [
    { prop: 'id', label: 'ID' },
    { prop: 'userid', label: '提交用户ID' },
    { prop: 'cellphone', label: '手机号' },
    { prop: 'status_cn', label: '状态' },
    { prop: 'workinfo_passed_times', label: '审核通过次数' },
    { prop: 'created_at', label: '提交时间' },
    { prop: 'updated_at', label: '更新时间' },
  ]
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const userWorkInfo = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/user-workinfo/user-workinfo.store.js